export default __webpack_public_path__ + "static/media/icon-logo-googleplay.3e9a3f18.png";